module.exports = __webpack_public_path__ + "static/media/need-doctor-on-demand.d1cc7626.jpg";